import React from 'react';
import { Layout } from './Layout';
import { LayoutProps, LayoutComponent } from './types';

export const Inline = ((props: LayoutProps) => (
  <Layout {...props} direction="inline" />
)) as LayoutComponent;
